/**
 * Lead capture endpoint configuration.
 * After deploying the Apps Script Web App (see lead_capture/SETUP.md), paste
 * the deployment URL here and redeploy the landing page.
 *
 * If this URL is left as the placeholder, the form will run in "demo mode":
 * step submissions are logged to the browser console and no data is sent.
 */
window.VP_LEAD_CAPTURE_URL = "https://script.google.com/macros/s/AKfycby1GQ01MOwf_jFog_2wkQtmi0MEJ_KiRm4t8ihRhG3FMjmL_arstPQQ0WZixMT5eHQw/exec";

/**
 * Region for this domain. Resolved automatically from window.location.hostname.
 * .ca → 'ca', everything else → 'us'.
 */
window.VP_REGION = (function () {
  try {
    return window.location.hostname.toLowerCase().endsWith(".ca") ? "ca" : "us";
  } catch (e) {
    return "us";
  }
})();

/**
 * Region-specific contact info shown to existing customers.
 */
window.VP_REGION_CONTACT = {
  us: {
    email: "sales@veryplants.com",
    tollFree: "1-800-686-6218",
    textSales: "+1 (463) 223-5776",
    textSalesLabel: "Text sales (US)",
  },
  ca: {
    email: "sales@veryplants.com",
    tollFree: "1-800-686-6218",
    textSales: "+1 (514) 427-8588",
    textSalesLabel: "Text sales (Canada)",
  },
};
